import type { RouteRecordRaw } from "vue-router"
import { useAuthStore } from "@core/stores/auth.store"
import { ensureAuthUserLoaded } from "@core/router/building.routes"
import PageResidualPower from "./pages/PageResidualPower.vue"

export const buildingShellChildren = [
    {
        path: "irve/simulation",
        name: "PageResidualPower",
        component: PageResidualPower,
        beforeEnter: async (to, _from, next) => {
            const authStore = useAuthStore()
            await ensureAuthUserLoaded(authStore)
            if (authStore.hasOfferIrve) {
                next()
            } else {
                next({
                    name: "PageBuildingMeter",
                    params: {
                        _id_building: String(to.params._id_building),
                    },
                })
            }
        },
    },
] as RouteRecordRaw[]
